export default "__VITE_ASSET__C5kKumrA__"